import axios from "axios";

export default axios.create({
  // baseURL: "https://natter.nattersearch.com/api/",
  baseURL: "https://nattersearch.nattersearch.com/api/",
  responseType: "json",
});
